'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookiesProvider = function (_Component) {
  _inherits(CookiesProvider, _Component);

  function CookiesProvider(props) {
    _classCallCheck(this, CookiesProvider);

    var _this = _possibleConstructorReturn(this, (CookiesProvider.__proto__ || Object.getPrototypeOf(CookiesProvider)).call(this, props));

    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new _universalCookie2.default();
    }
    return _this;
  }

  _createClass(CookiesProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        cookies: this.cookies
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return CookiesProvider;
}(_react.Component);

CookiesProvider.propTypes = {
  children: _propTypes.node,
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default)
};
CookiesProvider.childContextTypes = {
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
};
exports.default = CookiesProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie/lib/CookiesProvider.js
// module id = 2034
// module chunks = 0